const classes = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        px: 1,
        py: 1,
        height: '480px',
    },
    search: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
    },
    patient_card: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        padding: 1.5,
        borderRadius: 1,
        transition: 'all 0.2s',
        backgroundColor: 'background.paper',
        '&:hover': {
            backgroundColor: 'action.hover',
        },
    },
    patient_card_username: {
        fontSize: '0.95rem',
        fontWeight: 500,
        color: 'text.primary',
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
    patients_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxHeight: '400px',
        overflowY: 'scroll',
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
    },
    stack: {
        alignItems: 'center',
    },
    usersListCircularProgress: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 3,
    },
    search_button: {
        '&:disabled': {
            opacity: 0.5,
        },
    },
};

export default classes